import { render } from "./MainCardPreloadComp.vue?vue&type=template&id=7f7eb7b2&scoped=true&ts=true"
import script from "./MainCardPreloadComp.vue?vue&type=script&lang=ts"
export * from "./MainCardPreloadComp.vue?vue&type=script&lang=ts"

import "./MainCardPreloadComp.vue?vue&type=style&index=0&id=7f7eb7b2&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\user\\Documents\\Code\\VSProjects\\modboxProject\\modbox\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7f7eb7b2"]])

export default __exports__